import { Typography } from '@mui/material';

import { usePaymentMethod } from '@mopla/business-logic';

import { getLastFourDigits } from '../../../organisms/PaymentMethodForm/utils';

const capitalize = (s: string): string =>
	s ? s.charAt(0).toUpperCase() + s.slice(1) : s;

const hiddenNumber = '****';

/**
 * Compact, text-only summary of the saved payment method — the collapsed
 * subtitle of the Zahlung section. Reuses the shared
 * getLastFourDigits helper (wallet-aware: card / apple_pay / google_pay / SEPA);
 * cards show the brand ("Visa **** 4242"), wallets the provider name.
 */
export const PaymentMethodLabel = () => {
	const { defaultPaymentMethod } = usePaymentMethod();

	if (!defaultPaymentMethod) return null;

	const getLabel = (): string => {
		const pm = defaultPaymentMethod;
		switch (pm.type) {
			case 'card':
			case 'apple_pay':
			case 'google_pay':
				return `${capitalize(
					pm.card?.brand ?? ''
				)} ${hiddenNumber}${getLastFourDigits(pm)}`.trim();
			case 'sepa_debit':
				return `SEPA ${hiddenNumber}${getLastFourDigits(pm)}`;
			case 'paypal':
				return pm.paypal?.payer_email ?? 'PayPal';
			case 'revolut_pay':
				return 'Revolut Pay';
			case 'amazon_pay':
				return 'Amazon Pay';
			case 'klarna':
				return 'Klarna';
			case 'pay_by_bank':
				return 'Pay by Bank';
			default:
				return '';
		}
	};

	return (
		<Typography
			data-testid="PaymentMethodLabel"
			variant="l1"
			color="solutions.600"
		>
			{getLabel()}
		</Typography>
	);
};
